import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // ✅ Import hooks

import { Toast } from "../util/Toast";
import axios from "axios";

const ChangePassword = () => {
  // ✅ No more props needed

  const { id } = useParams(); // ✅ Replaces props.match.params.id
  const navigate = useNavigate(); // ✅ Replaces props.navigate

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
  });

  // ✅ No more useEffect needed to extract id from props

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password || !confirmPassword || password !== confirmPassword) {
      const error = {};

      if (!password) {
        error.password = "Please enter password!";
      }
      if (!confirmPassword) {
        error.confirmPassword = "Please enter confirm password!";
      }
      if (password !== confirmPassword) {
        error.confirmPassword = "Password & Confirm Password does not match";
      }

      return setError({ ...error });
    }

    axios
      .post(`admin/setPassword/${id}`, {
        // ✅ id now comes from useParams()
        newPass: password,
        confirmPass: confirmPassword,
      })
      .then((res) => {
        if (res.data.status) {
          Toast("success", "Password changed successfully!");
          setTimeout(() => {
            navigate("/"); // ✅ Replaces props.navigate("/")
          }, 3000);
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((error) => {
        Toast("error", error.message);
      });
  };

  return (
    <>
      <div className="login-page back__style">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-md-12 col-lg-4">
              <div className="card login-box-container">
                <div className="card-body">
                  <div className="authent-text">
                    <p className="text-danger mb-4 h5">Change Password</p>
                    <p>
                      If you have forgotten your password you can reset it here!
                    </p>
                  </div>
                  <form autoComplete="off">
                    <div className="mb-3">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="floatingPassword"
                          placeholder="password"
                          required
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                            setError((prev) => ({
                              ...prev,
                              password: e.target.value
                                ? ""
                                : "Please enter password!",
                            }));
                          }}
                        />
                        <label htmlFor="floatingPassword">Password</label>
                      </div>
                      {error.password && (
                        <div className="mt-2 ml-2 pl-1 text-left pb-1">
                          <span className="text-red font-size-lg">
                            {error.password}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="floatingConfirmPassword"
                          placeholder="confirm password"
                          required
                          value={confirmPassword}
                          onChange={(e) => {
                            setConfirmPassword(e.target.value);
                            setError((prev) => ({
                              ...prev,
                              confirmPassword: e.target.value
                                ? ""
                                : "Please enter confirm password!",
                            }));
                          }}
                        />
                        <label htmlFor="floatingConfirmPassword">
                          Confirm Password
                        </label>
                      </div>
                      {error.confirmPassword && (
                        <div className="mt-2 ml-2 pl-1 text-left pb-1">
                          <span className="text-red font-size-lg">
                            {error.confirmPassword}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-danger m-b-xs"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
